import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPin = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 17,
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M7.6051 1.61462C8.03841 0.661088 9.29077 0.433928 10.0314 1.17453L15.0615 6.20467C15.8021 6.94528 15.575 8.19763 14.6214 8.63095L10.1103 10.6809C9.98373 10.7384 9.88681 10.8461 9.84284 10.978L8.28402 15.6544C8.22922 15.8188 8.09321 15.9431 7.92456 15.983C7.7559 16.0228 7.57866 15.9724 7.45613 15.8499L4.27411 12.6679L0.707107 16.2349L0.705105 16.2329H0.00204659V15.5298L0 15.5278L3.567 11.9608L0.385057 8.77881C0.262525 8.65628 0.212173 8.47904 0.251987 8.31038C0.2918 8.14173 0.416101 8.00572 0.580498 7.95092L5.25884 6.39147C5.39075 6.3475 5.4984 6.25058 5.55593 6.12399L7.6051 1.61462ZM9.32426 1.88164C9.0774 1.63477 8.65994 1.71049 8.51551 2.02834L6.46633 6.5377C6.29375 6.91748 5.97081 7.20824 5.57506 7.34016L1.66423 8.64377L7.59117 14.5707L8.89415 10.6618C9.02607 10.266 9.31683 9.94308 9.69661 9.7705L14.2077 7.72054C14.5256 7.5761 14.6013 7.15865 14.3544 6.91178L9.32426 1.88164Z",
		fill: "#F5A623",
		stroke: "#F5A623"
	})]
});
const ForwardRef = forwardRef(SvgPin);
export default ForwardRef;
